export const AG_GRID_LOCALE_PT = {
    // Set Filter
    selectAll: '(Selecionar tudo)',
    selectAllSearchResults: '(Selecionar todos os resultados da pesquisa)',
    searchOoo: 'Pesquisar...',
    blanks: '(Espaços em branco)',
    noMatches: 'Sem correspondências',

    // Number Filter & Text Filter
    filterOoo: 'Filtrar...',
    equals: 'Iguais',
    notEqual: 'Não é igual',
    blank: 'Em branco',
    notBlank: 'Não em branco',
    empty: 'Escolha um',

    // Number Filter
    lessThan: 'Menos que',
    greaterThan: 'Maior que',
    lessThanOrEqual: 'Menor ou igual',
    greaterThanOrEqual: 'Maior ou igual',
    inRange: 'No alcance',
    inRangeStart: 'de',
    inRangeEnd: 'para',

    // Text Filter
    contains: 'Contém',
    notContains: 'Não contém',
    startsWith: 'Começa com',
    endsWith: 'Termina com',

    // Date Filter
    dateFormatOoo: 'aaaa-mm-dd',

    // Filter Conditions
    andCondition: 'E',
    orCondition: 'OU',

    // Filter Buttons
    applyFilter: 'Aplicar',
    resetFilter: 'Redefinir',
    clearFilter: 'Limpar',
    cancelFilter: 'Cancelar',

    // Filter Titles
    textFilter: 'Filtro de Texto',
    numberFilter: 'Filtro de Número',
    dateFilter: 'Filtro de data',
    setFilter: 'Definir filtro',

    // Side Bar
    columns: 'Colunas',
    filters: 'Filtros',

    // columns tool panel
    pivotMode: 'Modo Pivô',
    groups: 'Grupos de linhas',
    rowGroupColumnsEmptyMessage: 'Arraste aqui para definir grupos de linhas',
    values: 'Valores',
    valueColumnsEmptyMessage: 'Arraste aqui para agregar',
    pivots: 'Rótulos de coluna',
    pivotColumnsEmptyMessage: 'Arraste aqui para definir os rótulos das colunas',

    // Header of the Default Group Column
    group: 'Grupo',

    // Row Drag
    rowDragRows: 'linhas',

    // Other
    loadingOoo: 'Carregando...',
    noRowsToShow: 'Sem linhas para mostrar',
    enabled: 'Ativado',

    // Menu
    pinColumn: 'Coluna de pinos',
    pinLeft: 'Fixar à esquerda',
    pinRight: 'Fixar à direita',
    noPin: 'Sem alfinete',
    valueAggregation: 'Agregação de valor',
    autosizeThiscolumn: 'Dimensionar automaticamente esta coluna',
    autosizeAllColumns: 'Dimensionar automaticamente todas as colunas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    addToValues: 'Adicionar ${variável} aos valores',
    removeFromValues: 'Remover ${variable} dos valores',
    addToLabels: 'Adicionar ${variável} aos rótulos',
    removeFromLabels: 'Remover ${variável} dos rótulos',
    resetColumns: 'Redefinir colunas',
    expandAll: 'Expandir tudo',
    collapseAll: 'Fechar tudo',
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copiar com cabeçalhos',
    copyWithGroupHeaders: 'Copiar com cabeçalhos de grupo',
    paste: 'Colar',
    ctrlV: 'Ctrl+V',
    export: 'Exportar',
    csvExport: 'Exportação CSV',
    excelExport: 'Exportação Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Soma',
    min: 'Min',
    max: 'Máximo',
    none: 'Nenhum',
    count: 'Contar',
    avg: 'Média',
    filteredRows: 'Filtrado',
    selectedRows: 'Selecionado',
    totalRows: 'Total de linhas',
    totalAndFilteredRows: 'Linhas',
    more: 'Mais',
    to: 'para',
    of: 'de',
    page: 'Página',
    nextPage: 'Próxima página',
    lastPage: 'Última página',
    firstPage: 'Primeira página',
    previousPage: 'Página anterior',

    // Pivoting
    pivotColumnGroupTotals: 'Total',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Gráfico Dinâmico e Modo Dinâmico',
    pivotChart: 'Gráfico Dinâmico',
    chartRange: 'Intervalo do gráfico',

    columnChart: 'Coluna',
    groupedColumn: 'Agrupado',
    stackedColumn: 'Empilhado',
    normalizedColumn: '100% Empilhado',

    barChart: 'Bar',
    groupedBar: 'Agrupado',
    stackedBar: 'Empilhado',
    normalizedBar: '100% Empilhado',

    pieChart: 'Torta',
    pie: 'Torta',
    doughnut: 'Rosquinha',

    line: 'Linha',

    xyChart: 'X Y (Dispersão)',
    scatter: 'Dispersão',
    bubble: 'Bolha',

    areaChart: 'Área',
    area: 'Área',
    stackedArea: 'Empilhado',
    normalizedArea: '100% Empilhado',

    histogramChart: 'Histograma',

    combinationChart: 'Combinação',
    columnLineCombo: 'Coluna e Linha',
    AreaColumnCombo: 'Área e Coluna',

    // Charts
    pivotChartTitle: 'Gráfico Dinâmico',
    rangeChartTitle: 'Gráfico de alcance',
    settings: 'Configurações',
    data: 'Dados',
    format: 'Formato',
    categories: 'Categorias',
    defaultCategory: '(Nenhum)',
    series: 'Série',
    xyValues: 'Valores X Y',
    paired: 'Modo emparelhado',
    axis: 'Eixo',
    navigator: 'Navegador',
    color: 'Cor',
    thickness: 'Espessura',
    xType: 'Tipo X',
    automatic: 'Automático',
    category: 'Categoria',
    number: 'Número',
    time: 'Tempo',
    autoRotate: 'Rotação automática',
    xRotation: 'Rotação X',
    yRotation: 'Rotação Y',
    ticks: 'Carrapatos',
    width: 'Largura',
    height: 'Altura',
    length: 'Comprimento',
    padding: 'Preenchimento',
    spacing: 'Espaçamento',
    chart: 'Gráfico',
    title: 'Título',
    titlePlaceholder: 'Título do gráfico - clique duas vezes para editar',
    background: 'Plano de fundo',
    font: 'Fonte',
    top: 'Topo',
    right: 'Certo',
    bottom: 'Inferior',
    left: 'Esquerda',
    labels: 'Rótulos',
    size: 'Tamanho',
    minSize: 'Tamanho Mínimo',
    maxSize: 'Tamanho máximo',
    legend: 'Lenda',
    position: 'Posição',
    markerSize: 'Tamanho do marcador',
    markerStroke: 'Traço do marcador',
    markerPadding: 'Preenchimento de marcador',
    itemSpacing: 'Espaçamento de itens',
    itemPaddingX: 'Preenchimento de item X',
    itemPaddingY: 'Preenchimento de item Y',
    layoutHorizontalSpacing: 'Espaçamento Horizontal',
    layoutVerticalSpacing: 'Espaçamento vertical',
    strokeWidth: 'Largura do traço',
    offset: 'Deslocamento',
    offsets: 'Compensações',
    tooltips: 'Dicas',
    callout: 'Chamada',
    markers: 'Marcadores',
    shadow: 'Sombra',
    blur: 'Desfoque',
    xOffset: 'Deslocamento X',
    yOffset: 'Deslocamento Y',
    lineWidth: 'Largura da linha',
    normal: 'Normal',
    bold: 'Ousado',
    italic: 'Itálico',
    boldItalic: 'Negrito Itálico',
    predefined: 'Pré-definido',
    fillOpacity: 'Preencher opacidade',
    strokeOpacity: 'Opacidade da linha',
    histogramBinCount: 'Contagem de lixo',
    columnGroup: 'Coluna',
    barGroup: 'Bar',
    pieGroup: 'Torta',
    lineGroup: 'Linha',
    scatterGroup: 'X Y (Dispersão)',
    areaGroup: 'Área',
    histogramGroup: 'Histograma',
    combinationGroup: 'Combinação',
    groupedColumnTooltip: 'Agrupado',
    stackedColumnTooltip: 'Empilhado',
    normalizedColumnTooltip: '100% Empilhado',
    groupedBarTooltip: 'Agrupado',
    stackedBarTooltip: 'Empilhado',
    normalizedBarTooltip: '100% Empilhado',
    pieTooltip: 'Torta',
    doughnutTooltip: 'Rosquinha',
    lineTooltip: 'Linha',
    groupedAreaTooltip: 'Área',
    stackedAreaTooltip: 'Empilhado',
    normalizedAreaTooltip: '100% Empilhado',
    scatterTooltip: 'Dispersão',
    bubbleTooltip: 'Bolha',
    histogramTooltip: 'Histograma',
    columnLineComboTooltip: 'Coluna e Linha',
    areaColumnComboTooltip: 'Área e Coluna',
    customComboTooltip: 'Combinação personalizada',
    noDataToChart: 'Não há dados disponíveis para serem mapeados.',
    pivotChartRequiresPivotMode: 'Gráfico Dinâmico requer Modo Dinâmico ativado.',
    chartSettingsToolbarTooltip: 'Cardápio',
    chartLinkToolbarTooltip: 'Vinculado à rede',
    chartUnlinkToolbarTooltip: 'Desvinculado da grade',
    chartDownloadToolbarTooltip: 'Baixar gráfico',
    seriesChartType: 'Tipo de gráfico de série',
    seriesType: 'Tipo de série',
    secondaryAxis: 'Eixo Secundário',

    // ARIA
    ariaChecked: 'verificado',
    ariaColumn: 'Coluna',
    ariaColumnGroup: 'Grupo de Colunas',
    ariaColumnList: 'Lista de Colunas',
    ariaColumnSelectAll: 'Alternar selecionar todas as colunas',
    ariaDateFilterInput: 'Entrada do filtro de data',
    ariaDefaultListName: 'Lista',
    ariaFilterColumnsInput: 'Entrada de colunas de filtro',
    ariaFilterFromValue: 'Filtrar por valor',
    ariaFilterInput: 'Entrada de filtro',
    ariaFilterList: 'Lista de filtros',
    ariaFilterToValue: 'Filtrar por valor',
    ariaFilterValue: 'Valor do filtro',
    ariaFilteringOperator: 'Operador de filtragem',
    ariaHidden: 'escondido',
    ariaIndeterminate: 'indeterminado',
    ariaInputEditor: 'Editor de entrada',
    ariaMenuColumn: 'Pressione CTRL ENTER para abrir o menu da coluna.',
    ariaRowDeselect: 'Pressione ESPAÇO para desmarcar esta linha',
    ariaRowSelectAll: 'Pressione espaço para alternar a seleção de todas as linhas',
    ariaRowToggleSelection: 'Pressione espaço para alternar a seleção de linha',
    ariaRowSelect: 'Pressione ESPAÇO para selecionar esta linha',
    ariaSearch: 'Pesquisar',
    ariaSortableColumn: 'Pressione ENTER para classificar',
    ariaToggleVisibility: 'Pressione ESPAÇO para alternar a visibilidade',
    ariaUnchecked: 'desmarcado',
    ariaVisible: 'visível',
    ariaSearchFilterValues: 'Pesquisar valores de filtro',

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: 'Grupos de linhas',
    ariaValuesDropZonePanelLabel: 'Valores',
    ariaPivotDropZonePanelLabel: 'Rótulos de coluna',
    ariaDropZoneColumnComponentDescription: 'Pressione DELETE para remover',
    ariaDropZoneColumnValueItemDescription: 'Pressione ENTER para alterar o tipo de agregação',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Menu Coluna',
    ariaLabelCellEditor: 'Editor de células',
    ariaLabelDialog: 'Diálogo',
    ariaLabelSelectField: 'Selecionar campo',
    ariaLabelTooltip: 'Dica',
    ariaLabelContextMenu: 'Menu de contexto',
    ariaLabelSubMenu: 'Submenu',
    ariaLabelAggregationFunction: 'Função de agregação',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',
    rowsPerPage: 'Linhas por página:',

}
